import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Stack,
  Box,
  Paper,
} from '@mui/material';
import {
  poppins300,
  poppins400,
  poppins500,
  poppins600,
} from 'theme/common.style';
import AiBannerStar from 'assets/svg/AiBannerStar.svg';

const IdenticalSuggestionBuyerone = ({
  open,
  onClose,
  address,
  makeoffer,
  matchessm,
  matchesmd,
}) => {
  const AiBannerRectangle = ({ matchessm, matchesmd }) => {
    return (
      <svg
        width="57"
        height="57"
        viewBox="0 0 126 126"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_2101_2)">
          <path
            d="M123 3H3V123H123V3Z"
            stroke="url(#paint0_linear_2101_2)"
            stroke-width="6"
          />
          <path
            d="M66.542 86L63.5882 77.1101H45.7341L42.7803 86H33L49.2131 38.4968H60.1749L76.3223 86H66.542ZM48.1628 69.781H61.2252L54.6612 50.0333L48.1628 69.781ZM93 38.8361C93 40.4648 92.453 41.8446 91.359 42.9757C90.265 44.1067 88.9303 44.6722 87.355 44.6722C85.8234 44.6722 84.5106 44.1067 83.4166 42.9757C82.3225 41.8446 81.7756 40.4648 81.7756 38.8361C81.7756 37.2074 82.3225 35.8276 83.4166 34.6965C84.5106 33.5655 85.8234 33 87.355 33C88.9303 33 90.265 33.5655 91.359 34.6965C92.453 35.8276 93 37.2074 93 38.8361ZM82.7602 86V48.4046H92.0154V86H82.7602Z"
            fill="url(#paint1_linear_2101_2)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_2101_2"
            x1="17.6842"
            y1="-76.9999"
            x2="185.591"
            y2="126.429"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#6C2AD2" />
            <stop offset="1" stop-color="#77CFFE" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2101_2"
            x1="40.7685"
            y1="-57.3226"
            x2="183.707"
            y2="44.7775"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#6C2AD2" />
            <stop offset="1" stop-color="#77CFFE" />
          </linearGradient>
          <clipPath id="clip0_2101_2">
            <rect width="126" height="126" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        zIndex: 9999,
      }}
    >
      <DialogTitle display={'flex'} justifyContent={'left'}>
        <Typography
          variant="subtitle2"
          color="textSecondary"
          style={{ textAlign: 'left' }}
          sx={{
            ...poppins400,
            fontStyle: '14px',
            color: '#666666',
          }}
        >
          {address}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Stack marginLeft={2}>
          <Box
            display="flex"
            justifyContent="left"
            alignItems="center"
            gap={1}
            mt={1}
          >
            <Box>
              <AiBannerRectangle matchessm={matchessm} matchesmd={matchesmd} />
            </Box>

            <Typography
              component="span"
              sx={{
                padding: '4px 8px',
                fontWeight: 'bold',
                background:
                  'linear-gradient(to bottom right, #6C2AD2, #77CFFE)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent', // Makes text gradient-colored
                display: 'inline-block',
                ...poppins600,
                fontSize: '32px',
              }}
            >
              Buyer Assist
            </Typography>
          </Box>
          <Box mt={3}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: '16px',
                color: '#666666',
              }}
            >
              Market activity indicates whilst buyer interest remains high at
              similar offer values, your offer is unlikely to remain
              competitive.
            </Typography>
          </Box>

          <Box mt={2} mb={3}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: '16px',
                color: '#666666',
              }}
            >
              As the offer board leader you have an exclusive window of
              opportunity to increase your offer and maintain the lead.
            </Typography>
          </Box>
          <Box mt={3}>
            <Box
              mb={3}
              display={'flex'}
              justifyContent={'left'}
              alignItems={'center'}
            >
              <Typography
                sx={{
                  ...poppins600,
                  fontSize: '20px',
                  color: '#3D3D3D',
                }}
              >
                Ai Suggest
              </Typography>
            </Box>

            <Paper
              variant="outlined"
              style={{
                padding: '10px',
                marginBottom: '12px',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                gap: '2px',
                border: '1px solid #965CF0',
                borderRadius: '10px',
              }}
            >
              <img
                src={AiBannerStar}
                alt="Star"
                style={{
                  height: matchessm ? '30px' : '35px',
                  width: matchessm ? '30px' : '35px',
                  flexShrink: 0,
                }}
              />
              <Typography
                sx={{
                  ...poppins400,
                  fontSize: '16px',
                  color: '#666666',
                }}
                style={{ flex: 1 }}
              >
                Round number offers are commonly used and can reduce your
                opportunity to win the property.
              </Typography>
            </Paper>

            <Paper
              variant="outlined"
              style={{
                padding: '10px',
                marginBottom: '12px',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                gap: '2px',
                border: '1px solid #965CF0',
                borderRadius: '10px',
              }}
            >
              <img
                src={AiBannerStar}
                alt="Star"
                style={{
                  height: matchessm ? '30px' : '35px',
                  width: matchessm ? '30px' : '35px',
                  flexShrink: 0, // Ensures the image doesn't shrink
                }}
              />
              <Typography
                sx={{
                  ...poppins400,
                  fontSize: '16px',
                  color: '#666666',
                }}
                style={{ flex: 1 }}
              >
                Maintaining the highest offer position will boost your retreX
                profile.{' '}
              </Typography>
            </Paper>

            <Paper
              variant="outlined"
              style={{
                padding: '10px',
                marginBottom: '12px',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                gap: '2px',
                border: '1px solid #965CF0',
                borderRadius: '10px',
              }}
            >
              <img
                src={AiBannerStar}
                alt="Star"
                style={{
                  height: matchessm ? '30px' : '35px',
                  width: matchessm ? '30px' : '35px',
                  flexShrink: 0, // Ensures the image doesn't shrink
                }}
              />
              <Typography
                sx={{
                  ...poppins400,
                  fontSize: '16px',
                  color: '#666666',
                }}
              >
                Once campaigns close, offer board leaders will gain exclusive
                insights and access to off-market opportunities.
              </Typography>
            </Paper>
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ paddingRight: '20px', marginBottom: '10px' }}>
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{
            color: '#666666',
            border: '1px solid #1123471A',
            textTransform: 'none',
          }}
        >
          Close
        </Button>

        <Button
          onClick={() => {
            makeoffer();
            onClose();
          }}
          variant="contained"
          sx={{ backgroundColor: '#4CA4D6', textTransform: 'none' }}
        >
          Make Offer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IdenticalSuggestionBuyerone;
